import React, { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

const Login = lazy(() => import('../pages/Login'))
const Ramais = lazy(() => import('../pages/Ramais'))
const Dashboard = lazy(() => import('../pages/Dashboard'))
const Recover = lazy(() => import('../pages/Login/password/Recover'))
const Change = lazy(() => import('../pages/Login/password/Change'))

import Authenticator from './Authenticator'

const LazyFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <p>Carregando...</p>
  </div>
)


function AppRoutes() {
  return (
        <Suspense fallback={<LazyFallback />}>
          <Routes>
              <Route element={<Authenticator />}>
                  <Route path='/' element={<Navigate to='/dashboard' />} />
                  <Route path='/dashboard' element={<Dashboard />} />
              </Route>

              <Route path='/login' element={<Login />}/>
              <Route path="/ramais/:nomePref/:nomelista" element={<Ramais />}/>
              <Route path="/recover" element={<Recover />}/>
              <Route path="/changeforgot/:token" element={<Change />}/>
              <Route path='*' element={<h1>404</h1>}/>
          </Routes>
        </Suspense>
  )
}

export default AppRoutes